const dnGroupApiGatewaysURLs = {
  'test': 'https://api-test.dngroup.com',
  'stage': 'https://api-stage.dngroup.com',
  'prod': 'https://api.dngroup.com',
};


export const BASE_URLS = {
  SUBSCRIPTION_API: '/subscription/api/',
  DN_SUBSCRIPTION_API: '/bli-abonnent/api/',
  NHST_AUTH_API: '/oneid/auth/',
  ZEPHR_PUBLIC_API: '/',
  SUB_AUTH_API: '/auth/user/api/',
  DN_GROUP_API_GATEWAY: dnGroupApiGatewaysURLs
};

export const X_TRACE_ID_HEADER = 'X-Trace-Id';
export const X_IDEMPOTENT_HEADER = 'X-IDEMPOTENT-KEY';
